module.exports = __webpack_public_path__ + "img/ai.f03dc02e.svg";